import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function AlertDialog(props) {

  const { confirmButtonColor = 'primary', confirmButtonTitle } = props;

  const handleClose = () => {
    props.setOpen(false);
  }

  const handleConfirm = () => {
    handleClose();
    props.confirm();
  }

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{props.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Avbryt
        </Button>
        <Button onClick={handleConfirm} color={confirmButtonColor} variant='contained'>
          {confirmButtonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;